import { useGetTimePointSubmissionDetails } from '@features/subject/hooks/useGetTimePointSubmissionDetails'
import { Stack, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'

export default function NewTimepointBox({
  timepointSubmissionId,
  subjectId,
}: {
  timepointSubmissionId: string | null
  subjectId: string | null
}) {
  const { studyId } = useParams()
  const { data, error, isLoading } = useGetTimePointSubmissionDetails(
    ['TimePointsDetails', studyId!, subjectId!, timepointSubmissionId!],
    {
      study_id: studyId!,
      subject_id: subjectId!,
      timepoint_submission_id: timepointSubmissionId!,
    },
  )

  if (isLoading) {
    return <div>Loading...</div>
  }

  if (error || !data || !data.data) {
    return <div>Error: {error?.message}</div>
  }

  return (
    <Stack
      padding={4}
      spacing={3}
      width={350}
      borderRadius={4}
      sx={{
        border: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between" justifyItems="center">
        <Typography color="text.secondary" variant="body2">
          Timepoint
        </Typography>
        <Typography color="text.primary" variant="subtitle2">
          {data.data.timepoint_submission.name}
        </Typography>
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between" justifyItems="center">
        <Typography color="text.secondary" variant="body2">
          Subject ID
        </Typography>
        <Typography color="text.primary" variant="subtitle2">
          {data.data.subject.pseudo_id}
        </Typography>
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between" justifyItems="center">
        <Typography color="text.secondary" variant="body2">
          Blind Code
        </Typography>
        <Typography color="text.primary" variant="subtitle2">
          {data.data.subject.blind_code}
        </Typography>
      </Stack>
    </Stack>
  )
}
